<template>
    <DsDialog
      v-model="localVisible"
      :before-close="handleBeforeClose"
      :show-close="false"
      custom-class="detalleProducto"
      width="700px"
      max-width="85%"
      height="auto"
      max-height="90vh"
      append-to-body
      :data-testid="TEST_ID.DETALLE_PRODUCTO_DIALOG.ROOT">

        <template #header>
            <el-row class="headerDialog">
                <el-col :span="24">{{$t('PRODUCTO_detalle')}}</el-col>
            </el-row>
        </template>
    <!-- Cuerpo -->
    <div>
        <el-row>
            <el-col :span="24" class="blackLabel">{{ productoSafe.Nombre || '' }}</el-col>
        </el-row>
        <el-row>
            <el-col :span="8" class="greyLabel" :data-testid="TEST_ID.DETALLE_PRODUCTO_DIALOG.DESCRIPCION_LABEL">{{$t('GENERAL_descripcion')}}:</el-col>
          <el-col :span="16" class="valueLabel">{{ productoSafe.Descripcion || '' }}</el-col>
        </el-row>
        <el-row>
            <el-col :span="8" class="greyLabel" :data-testid="TEST_ID.DETALLE_PRODUCTO_DIALOG.PRECIO_UNITARIO_LABEL">{{$t('PRODUCTO_precio_unitario')}}:</el-col>
          <el-col :span="16" class="valueLabel">${{ productoSafe.Precio ?? '' }}</el-col>
        </el-row>
        <el-row>
            <el-col :span="8" class="greyLabel" :data-testid="TEST_ID.DETALLE_PRODUCTO_DIALOG.IVA_LABEL">{{$t('PEDIDO_iva')}}:</el-col>
          <el-col :span="16" class="valueLabel">{{ productoSafe.IVA ?? '' }}%</el-col>
        </el-row>
        <el-row>
            <el-col :span="8" class="greyLabel" :data-testid="TEST_ID.DETALLE_PRODUCTO_DIALOG.BONIFICACION_LABEL">{{$t('PEDIDO_bonificacion')}}:</el-col>
          <el-col :span="16" class="valueLabel">{{ productoSafe.BonificacionPorcentaje ?? '' }}%</el-col>
        </el-row>
        <el-row>
          <el-col :span="8" class="greyLabel" :data-testid="TEST_ID.DETALLE_PRODUCTO_DIALOG.UNIDAD_MEDIDA_LABEL">{{$t('PEDIDO_unidad_medida')}}:</el-col>
          <el-col :span="16" class="valueLabel">{{ productoSafe.UnidadMedida || '' }}</el-col>
        </el-row>
    </div>

    <template #footer>
      <span class="dialog-footer">
        <el-button class="btnConfirm" @click="cancelar" :data-testid="TEST_ID.DETALLE_PRODUCTO_DIALOG.BUTTON_CERRAR">{{ cancelBtn || $t('GENERAL_cancelBtn') }}</el-button>
      </span>
    </template>

    </DsDialog>
</template>

<script>
  import DsDialog from "./DsDialog.vue";
  import TEST_ID from "@/testIds.json";

  export default {
    name: 'DetalleProductoDialog',
    components: { DsDialog },
    props: {
      visible: Boolean,
      cancelBtn: String,
      confirmBtn: String,
      onClose: Function,
      producto: {
        type: Object,
        default: () => ({}),
      },
    },
    data(){
      return {
        localVisible: false,
        TEST_ID,
      }
    },
    watch: {
      visible(newVal) {
        this.localVisible = newVal;
      }
    },
    computed: {
      productoSafe() {
        return this.producto || {};
      },
    },
    methods: {
      handleBeforeClose() {
        if (typeof this.onClose === "function") {
          this.onClose(false);
        }

        return false;
      },
      cancelar(){
          if (typeof this.onClose === "function") {
            this.onClose(false);
          }
      },
    }
  }
  </script>
  
  <style>
    .detalleProducto .ds-dialog__header {
        background-color: var(--main-color);
        color: #ffffff;
        font-size: 1.5em;
        font-weight: bold;
        padding: 10px 0 10px 20px;
    }

    .detalleProducto .ds-dialog__title {
      text-align: left;
    }

    .headerDialog {
      width: 100%;
      text-align: left;
    }

    .dialog-footer {
      display: flex;
      width: 100%;
      justify-content: flex-end;
    }

    .detalleProducto .ds-dialog__footer {
      border-top: 1px solid #e4e7ed;
    }

    .detalleProducto .greyLabel,
    .detalleProducto .valueLabel {
      font-size: 14px;
      font-family: inherit;
      text-align: left;
      line-height: 1.4;
    }

    .detalleProducto .valueLabel {
      color: #6b6b6b;
    }
  
  </style>